import Vue from 'vue'
import '@mdi/font/css/materialdesignicons.css'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import * as VueGoogleMaps from "vue2-google-maps";
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete';
import { apolloProvider } from './graphql/apollo'
import "@/style/application.scss"
import errorHandler from './plugins/errorHandler'
import VueI18n from 'vue-i18n'
import messages from './i18n'
import wysiwyg from "vue-wysiwyg"
import VueApexCharts from 'vue-apexcharts'

Vue.config.productionTip = false
Vue.use(errorHandler)
Vue.component('apexchart', VueApexCharts)
Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'es', // TODO: dynamize
  messages
})

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCtS0bjOIKK6qxAespld02WDnjHk-xTOqc",
    libraries: "places", // necessary for places input
    region: "ar",
    language: "es"
  }
})

Vue.use(wysiwyg, {
  hideModules: {
    "image": true,
    link: true,
    code: true,
    table: true,
    separator: true
  },
  locale: 'es'
})

Vue.use(VuetifyGoogleAutocomplete, {
  vueGoogleMapsCompatibility: true,
});

new Vue({
  router,
  store,
  vuetify,
  i18n,
  apolloProvider,
  render: function (h) { return h(App) }
}).$mount('#app')
